@if (order(); as order) {
  <div class="flex flex-column h-100">
    <div class="top-header">
      <div class="order-number">
        Details for <br /><b>{{ order.trackingNumber }}</b>
      </div>
      @if (confirmedData()?.time) {
        <p class="history-header">
          Est. Arrival Time: <br />
          {{
            (confirmedData()!.time | date: "longDate") +
              " - " +
              (expectedDeliveryDate() | date: "longDate")
          }}
        </p>
      }
    </div>
    <div class="container flex-1 overflow-y">
      @if (type() === "new") {
        <div class="confirm-box">
          <p class="flex flex-row font-big">
            <img src="icons/location.svg" class="icon" />
            @if (confirmedData()?.address) {
              <span>{{ confirmedData()!.address }}</span>
            } @else {
              <span>
                {{
                  order.savedAddresses && order.savedAddresses.length
                    ? "Address not available, use this address:"
                    : "Address not available."
                }}
              </span>
            }
          </p>
          @if (!order.address) {
            <mat-radio-group aria-label="Select an option">
              @for (address of order.savedAddresses; track $index) {
                <mat-radio-button
                  class="radio-button"
                  [value]="$index"
                  (click)="selectAddress($index)"
                >
                  <b>{{ address.name }}</b> {{ address.area }}
                </mat-radio-button>
              }
            </mat-radio-group>
          }
          <p class="flex flex-row font-big">
            <img src="icons/calendar.svg" class="icon" />
            @if (!isOrderPickedUp()) {
              <span>Not Received Yet</span>
            } @else {
              <span>{{
                order.dropOffEstimatedTime
                  ? (order.dropOffEstimatedTime | date)
                  : "pick up +3 days"
              }}</span>
            }
          </p>
          <!-- @if (lt() !== "t" && isOrderPickedUp()) { -->
          @if (isOrderPickedUp()) {
            <p class="flex flex-row font-big">
              <img src="icons/clock.svg" class="icon" />
              {{
                confirmedData()?.time
                  ? (confirmedData()!.time | date: "shortTime")
                  : "disable/hide for now"
              }}
            </p>
          }
          <!-- <button
            type="button"
            class="primary-button"
            (click)="confirm()"
            [disabled]="
              lt() !== 't' &&
              (!confirmedData()?.address || !confirmedData()?.time)
            "
          > -->
          <button
            type="button"
            class="primary-button"
            (click)="confirm()"
            [disabled]="!confirmedData()?.address || !confirmedData()?.time"
          >
            Confirm
          </button>
          <button type="button" class="secondary-button" (click)="edit()">
            Edit
          </button>
        </div>
      }
      @if (isTrackable()) {
        <button type="button" class="primary-button" (click)="liveTrack()">
          Track it live
        </button>
      }

      <div class="order-history">
        <div class="track-story-container">
          @for (story of customStory(); track $index) {
            <div class="track-story" [class.filled]="story.date">
              <div class="track-data">
                <span class="track-date">
                  {{ story.date | date: "h:mm - EE MMMM d, y" }}
                </span>
                <p class="track-status">
                  {{ story.status }}
                </p>
                @if (story.details?.failReason) {
                  <span class="track-location">{{
                    story.details!.failReason
                  }}</span>
                }
                @if (story.details?.carrier) {
                  <span class="track-location">{{
                    story.details!.carrier!.city
                  }}</span>
                }
                @if (story.statusCode === "19") {
                  <span class="delivery_proofs">
                    <a
                      [href]="story.details!.proofOfDeliveryImageUrl"
                      target="_blank"
                    >
                      <span>PROOF OF DELIVERY</span>
                      <img src="imgs/cloud-download.svg" />
                    </a>
                  </span>
                }
              </div>
            </div>
          }
        </div>
      </div>
      @if (type() === "edit" || type() === "none") {
        <div>
          <div class="box">
            <p><b>Delivery Address</b></p>
            <p>{{ confirmedData()?.address }}</p>
            <!-- @if (type() !== "none" && lt() !== "l") { -->
            @if (type() !== "none") {
              <a
                class="box-link flex justify-end align-center"
                (click)="boxAction('map')"
              >
                change <span class="material-icons">arrow_right_alt</span>
              </a>
            }
          </div>
          <!-- @if (lt() !== "t") { -->
          @if (allowPreferredDateConfirmation()) {
            <div class="box">
              <p><b>Delivery Time</b></p>
              <p>
                <br />
                @if (confirmedData()?.time) {
                  <span
                    >{{ confirmedData()!.time | date: "h a" }} -
                    {{ expectedDeliveryTime() | date: "h a" }}</span
                  >
                }
              </p>
              @if (type() !== "none") {
                <a
                  class="box-link flex justify-end align-center"
                  (click)="boxAction('time')"
                >
                  Reschedule <span class="material-icons">arrow_right_alt</span>
                </a>
              }
            </div>
          }
          @if (order.deliveryCode) {
            <div class="box">
              <p><b>Delivery Code</b></p>
              <p>Share your code with your assistant.</p>
              <p class="delivery-code">{{ order.deliveryCode }}</p>
            </div>
          }
        </div>
      }
    </div>
  </div>
}
